import { createSlotRecipe } from './runtime.js';

const buttonConfig = {"name":"button","slots":["root","icon","startIcon","endIcon"],"variantMap":{"color":["error","impact","inherit","primary","secondary"],"fullWidth":["true"],"selected":["true"],"size":["large","medium","small","xLarge","xSmall"],"strong":["true"],"variant":["contained","outlined","text"]}}

export const button = /* @__PURE__ */ createSlotRecipe(buttonConfig)